<template>
  <div class="card-header d-flex flex-row justify-content-between align-items-center" :class="classes">
  <slot></slot>
  </div>
</template>

<script>
import checkPermissions from '../../../mixins/checkPermissions';

export default {
  name: "ks-card-header",
  mixins: [checkPermissions],
  computed: {
    screenSizeId() {
      return app.layout.screenSizeId;
    },
    data_provider_ref() {
      return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
    },
    dataProvider() {
      return this.$parent.dataProvider ? this.$parent.dataProvider : null;
    },
    type() {
      return this.$parent.type ? this.$parent.type : null;
    }
  },
  props: {
    classes: {type: String, default: null}
  },
  data() {
    return {
      multiCampaign: null
    }
  }
}
</script>
